module.exports = __webpack_public_path__ + "static/media/Skipped Box.eaf86677.svg";